import { ALL_SENSOR_STATUS_MAP, type SensorStatus } from '../types';

interface SensorStatusBadgeProps {
  status: number;
}

/**
 * Color-coded badge for all 9 sensor statuses
 */
export function SensorStatusBadge({ status }: SensorStatusBadgeProps) {
  const config = ALL_SENSOR_STATUS_MAP[status as SensorStatus];

  if (!config) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
        Unknown ({status})
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor}`}
    >
      {config.label}
    </span>
  );
}
